import { InputField } from "@hatch-digital-nl/abs-storybook/legacy";
import { FormEvent, InvalidEvent, JSX, useState } from "react";
import { useAssociatedFieldId } from "../../../common/utils/useAssociatedFieldId";

interface Props {
    id: number;
    type: string;
    disabled?: boolean;
    value?: string;
    onChange?: (value: string) => void;
    onInput?: (event: FormEvent<HTMLInputElement>) => void;
    required?: boolean;
    title?: string;
    optional?: boolean;
    errorMessage?: string;
    isError?: boolean;
    isSuccess?: boolean;
    iconEdit?: string;
    onClick?: () => void;
    placeholder?: string;
    changeInputField?: () => void;
}

export const InputFieldComponent = (props: Props): JSX.Element => {
    const {
        id,
        value,
        onChange,
        type,
        disabled,
        required,
        title,
        optional,
        onInput,
        errorMessage,
        isError,
        isSuccess,
        iconEdit,
        onClick,
        placeholder,
        changeInputField,
    } = props;

    const [inputError, setInputError] = useState<{
        [key: string]: string | null;
    }>({});
    const { fieldId, fieldRef } = useAssociatedFieldId();

    return (
        <div className={"c-edit-employee-modal__form-group"}>
            <div className={"c-edit-employee-modal__form-group__optional"}>
                {title && <label htmlFor={fieldId}>{title}</label>}
                {optional && <p>optioneel</p>}
                {!optional && changeInputField && (
                    <button
                        type="button"
                        className={
                            "c-edit-employee-modal__form-group__optional__change-input"
                        }
                        onClick={changeInputField}
                    >
                        <u>wijzigen</u>
                    </button>
                )}
            </div>
            <div ref={fieldRef}>
                <InputField
                    onChange={(event: string) => {
                        // Don't reset inputError here, let the parent component control it
                        if (onChange) {
                            onChange(event);
                        }
                    }}
                    required={required}
                    value={value || ""}
                    type={type}
                    placeHolder={placeholder}
                    disabled={disabled}
                    onInput={onInput}
                    isError={isError || !!inputError[id]}
                    // Add success class directly to className when isSuccess is true
                    className={isSuccess ? "c-input-field--success" : ""}
                    onInvalid={(event: InvalidEvent<HTMLInputElement>) => {
                        event.preventDefault();

                        if (
                            (event.target as HTMLInputElement).validity
                                .valueMissing
                        ) {
                            setInputError((prevErrors) => ({
                                ...prevErrors,
                                [id]: errorMessage,
                            }));
                        }

                        if (
                            (event.target as HTMLInputElement).validity
                                .typeMismatch
                        ) {
                            setInputError((prevErrors) => ({
                                ...prevErrors,
                                [id]: "Ongeldig formaat",
                            }));
                        }
                    }}
                    iconEdit={iconEdit}
                    onClick={onClick}
                />
            </div>
            {inputError[id] && (
                <p className={"c-error-message"}>{inputError[id]}</p>
            )}
        </div>
    );
};
